import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Net Worth Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/net-worth/" title="Net Worth Calculator" width="100%" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
